var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"items":_vm.quarters,"offset-y":"","item-text":"item2","item-value":"item1","rules":[_vm.rules.required],"required":"","dense":""},on:{"change":function($event){return _vm.onValueChanged()}},model:{value:(_vm.txt_quarter),callback:function ($$v) {_vm.txt_quarter=$$v},expression:"txt_quarter"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }